export const MESSAGE_INPUT_ID = "textarea_ref";
